import { createSelector } from '@ngrx/store'
import { AppState } from '../../../../store/app.state'

import * as fromLoginPage from '../reducers/login-page.reducer'

export const getLoginPageState = (state: AppState) => state.loginPage

export const getLoginPagePending = createSelector(
  getLoginPageState,
  fromLoginPage.getPending
)

export const getLoginPageError = createSelector(
  getLoginPageState,
  fromLoginPage.getError
)



// WEBPACK FOOTER //
// ./src/app/shared/auth/store/selectors/login-page.selectors.ts